export enum UserType {
  User = 'user',
  Admin = 'admin',
  Housekeeper = 'housekeeper',
  Maintainer = 'mantainer',
}
